module.exports = __webpack_public_path__ + "img/duppoi.acd090e6.jpg";